import { CtxBodyFascicolo } from './ctx-body-fascicolo';
import { DescrittoreSezione } from './descrittore-sezione';
import { FascicoloFull } from './fascicolo/fascicolo-full';
import { StatoInserimento } from './stato-inserimento';

export class CtxBodyFascicoloIns extends CtxBodyFascicolo {
  statoInserimento: StatoInserimento;
  constructor(descrittori: DescrittoreSezione[], fascicolo: FascicoloFull, statoInserimento: StatoInserimento) {
    super(descrittori, fascicolo);
    this.statoInserimento = statoInserimento;
  }
}
